import axios from "axios";
import { userManager } from "@/auth/oidc";

const BASE = import.meta.env.VITE_API_BASE_URL || "https://localhost:7188";
const CLIENT_ID = import.meta.env.VITE_CLIENT_ID || "vue_spa";

// Ensure base URL ends with /api
const API_BASE = BASE.endsWith("/api") ? BASE : `${BASE}/api`;

const apiClient = axios.create({
  baseURL: API_BASE,
  headers: {
    "Content-Type": "application/json",
    "X-Client-Id": CLIENT_ID,
  },
  withCredentials: true,
});

let handlingUnauthorized = false;

// Ensure Bearer token is sent (apiClient is separate from axios defaults)
apiClient.interceptors.request.use(async (config) => {
  const user = await userManager.getUser();
  if (user?.access_token) {
    config.headers.Authorization = `Bearer ${user.access_token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (
      error.response?.status === 401 &&
      !error.config?.skipAuthRedirect &&
      !handlingUnauthorized
    ) {
      handlingUnauthorized = true;
      try {
        const { useAuthStore } = await import("@/stores/auth");
        const returnPath = window.location.pathname + window.location.search;
        await useAuthStore().recoverToLogin("unauthorized", returnPath);
      } catch (recoveryError) {
        console.error("[API] Unable to restart login:", recoveryError);
      } finally {
        handlingUnauthorized = false;
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
